import React, { Component, PropTypes } from 'react'
import Helmet from 'react-helmet'
import { Link as RouterLink } from 'react-router'
import { prefixLink } from 'gatsby-helpers'
import { config } from 'config'

import { colors, breakpoints } from '../constants/theme'
const { min1920, min1440, min1024, min768, min480, min360 } = breakpoints

import Section from '../components/Section'
import Column from '../components/Column'
import Row from '../components/Row'
import Spacer from '../components/Spacer'
import Container from '../components/Container'
import Page from '../components/Page'
import Icon from '../components/Icon'
import Image from '../components/Image'

import Heading1 from '../styleguide/Heading1'
import Heading2 from '../styleguide/Heading2'
import Heading3 from '../styleguide/Heading3'
import Heading4 from '../styleguide/Heading4'
import Heading5 from '../styleguide/Heading5'
import Heading6 from '../styleguide/Heading6'
import Paragraph from '../styleguide/Paragraph'
import Navigation from '../styleguide/Navigation'
import Link from '../styleguide/Link'
import LinkList from '../styleguide/LinkList'
import Footer from '../styleguide/Footer'
import Subtext from '../styleguide/Subtext'
import Services from '../styleguide/Services'
import Quote from '../styleguide/Quote'
import QuoteAuthor from '../styleguide/QuoteAuthor'
import Button from '../styleguide/Button'
import Line from '../styleguide/Line'

import FelaProvider from '../containers/FelaProvider'

const metaData = [ {
  name: 'description',
  content: 'Wir konzipieren, designen, entwickeln und betreiben anspruchsvolle Applikationen sowie komplexe und skalierbare Client-Server Systeme auf aktuellsten Web Stacks.'
}, {
  name: 'keywords',
  content: 'web agency'
} ]


const ErrorPage = (props, {width}) => (
  <FelaProvider>
    <Page
      bgColor={colors.background}
      style={{ minHeight: '100vh', height: '100%', paddingTop: 0 }}>
      <Container color='white' flex='1 0 auto'>
        <Section flex='1 0 auto' alignSelf='stretch' center>
          <Helmet
            title='Ninja Concept | Sophisticated web & mobile applications'
            meta={metaData}/>
          <Row>
            <Column sizes={{[min768]: 12}}>
              <Section alignSelf='stretch' flex='1 0 auto' center>
              <Image base={'/images/logo/ninja_inverted'} style={{paddingRight: width > 480 ? 16:12}} sizes={[ 480 ]}  />
            </Section>
            <Spacer size={10} sizes={{ [ min480]: 14, [ min1440]: 16 }} />
              <Heading1 textAlign='center' style={{fontSize: width>480 ? 100 : 72, lineHeight: 1.2}}>
                404
              </Heading1>
            </Column>
          </Row>
          <Spacer size={11} sizes={{ [ min480]: 14, [ min768]: 18, [ min1440]: 24 }} />
          <Row>
            <Column sizes={{[min768]: 12}} style={{padding: '0 30px'}}>
              <Heading3 lora textAlign='center'>
 „Gomen-ne“ - das ist Japanisch für „Sorry!“
  </Heading3>
              <Spacer size={10} sizes={{ [ min480]: 14, [ min1440]: 16 }} />
              <Paragraph textAlign='center'>
                Unsere Ninjas konnten die von Ihnen gesuchte Seite leider nicht finden.
  </Paragraph>
  <Spacer size={42} sizes={{ [min768]: 48, [min1024]: 54, [min1920]: 60}} />
  <Button
    color='white'
    hoverColor={colors.highlight}
    activeColor={colors.highlight}
    activeFontColor={colors.text}
    text={<RouterLink to={prefixLink('/')}>Zur Startseite</RouterLink>} />
    <Spacer size={42} sizes={{ [min768]: 48, [min1024]: 54, [min1920]: 60}} />
            </Column>
          </Row>
        </Section>
      </Container>
    </Page>
  </FelaProvider>
)

ErrorPage.contextTypes = {
  width: PropTypes.number
}

class DeviceProvider extends Component {
  static childContextTypes = {
    width: PropTypes.number
  };

  constructor(props, context) {
    super(props, context)
    this.state = { width: 0 }
  }

  updateDevice = () => {
    this.setState({
      width: window.innerWidth
    })
  }


  getChildContext() {
    return {
      width: this.state.width
    }
  }

  componentDidMount() {
    this.updateDevice()

    window.addEventListener('resize', () => {
      this.updateDevice()
    })
  }

  render() {
    return this.props.children
  }
}


export default () => (
  <DeviceProvider>
    <ErrorPage />
  </DeviceProvider>
)



// WEBPACK FOOTER //
// ./404.js